<template>
  <div>
    <div class="contact-info" @click="addOffer">
      <button class="edit-button mx-5">
        <i class="fa fa-plus"></i> إضافة عرض جديد
      </button>
    </div>
    <div class="contact-container contact-card">
      <div class="contact-item">
        <div class="contact-info">
          <h3 style="text-align: center">قائمة العروض</h3>
        </div>
        <div>
          <div class="container containerQuestions">
            <div class="accordion">
              <dl v-for="(offer, index) in offers" :key="index">
                <dt>
                  <a class="offerTitle">
                    <span class="offer-details" @click="openModal(offer)">
                      <i class="fas fa-eye" style="cursor: pointer"></i>
                    </span>
                    عرض {{ offer }}%
                    <span class="delete-offer" @click="deleteOffer(offer)">
                      <i class="fa fa-times"></i>
                    </span>
                  </a>
                </dt>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal to display product details -->
    <b-modal v-model="isModalOpen" title="المنتجات الموجودة بالعرض" size="lg">
      <div v-if="isLoading" class="loader">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-md-4" v-for="(product, index) in offerProducts[clickedOffer]" :key="index">
          <div class="card mb-4">
            <vue-load-image>
              <template v-slot:image>
                <img :src="'https://jebsenboard.onrender.com/image/Product/' + product.image" class="card-img-top"
                  alt="Product Image" />
              </template>
              <template v-slot:preloader>
                <div class="spinner-border text-primary" role="status" style="text-align: center">
                  <span class="sr-only">Loading...</span>
                </div>
              </template>
              <template v-slot:error>Image load fails</template>
            </vue-load-image>
            <div class="card-body" style="text-align: center">
              <h5 class="card-title mb-3" style="font-weight: 800">
                {{ product.name }}
              </h5>
              <a :href="`/admin/product-details/${product.id}`" class="btn btn-primary">
                <i class="fas fa-eye"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

  </div>
</template>

<script>
import Axios from "../../../Axios";
import Swal from "sweetalert2";
import { BModal } from "bootstrap-vue";
import VueLoadImage from "vue-load-image";

export default {
  components: {
    BModal,
    "vue-load-image": VueLoadImage,
  },
  data() {
    return {
      offers: [],
      isModalOpen: false,
      offerProducts: {},
      clickedOffer: null,
      isLoading: false,
    };
  },
  methods: {
    openModal(offer) {
      this.isModalOpen = true;
      this.clickedOffer = offer;
      this.isLoading = true;

      Axios.get(`/products/offer?offer=${offer}`)
        .then((response) => {
          this.offerProducts[offer] = response.data.products;
          this.isLoading = false;
          // console.log(this.offerProducts);
        })
        .catch((error) => {
          this.isLoading = false;
          // console.error(error);
        });
    },
    closeModal() {
      this.isModalOpen = false;
      this.clickedOffer = null;
    },
    addOffer() {
      this.$router.push("/admin/add-offer");
    },
    fetchOffers() {
      Axios.get("/products/offers")
        .then((response) => {
          // console.log(response.data);
          this.offers = response.data.map((item) => item.offer);
        })
        .catch((error) => {
          // console.error(error);
        });
    },
    deleteOffer(offer) {
      Swal.fire({
        title: "هل أنت متأكد؟",
        text: "هل تريد حقًا حذف هذا العرض؟",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "متأكد",
        cancelButtonText: "إلغاء",
        dangerMode: true,
      }).then((result) => {
        if (result.isConfirmed) {
          // Creating FormData instance
          let formData = new FormData();
          // Appending 'offer' to the FormData
          formData.append('offer', offer);

          // Modifying the Axios.delete request to use FormData
          Axios.delete(`/products/offers`, {
            data: formData,
            // Axios config for sending form-data
            headers: { 'Content-Type': 'multipart/form-data' },
          })
            .then((response) => {
              Swal.fire("تم الحذف!", "تم حذف العرض بنجاح.", "success");
              this.fetchOffers();
              // console.log(response);
            })
            .catch((error) => {
              Swal.fire("خطأ!", "حدث خطأ أثناء الحذف.", "error");
              // console.error(error);
            });
        }
      });
    },

  },
  mounted() {
    this.fetchOffers();
  },
};
</script>

<style scoped>
.loader {
  text-align: center;
  font-size: 18px;
  margin-top: 20px;
}

.offerTitle {
  background-color: #8d8a87;
  border-bottom: 1px solid #797775;
  position: relative;
}

.offerTitle:hover {
  background-color: #797775;
}

.delete-offer {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: rgb(224, 16, 16);
  color: white;
  padding: 0.2em 0.4em;
  cursor: pointer;
  border-radius: 25px;
}
</style>
